import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import Dashboard from './Dashboard';
import AdminDashboard from './AdminDashboard';

const DashboardRouter = () => {
  const { hasRole } = useAuth();
  
  // Check if user is admin (not superadmin)
  const isAdmin = hasRole('admin') && !hasRole('super_admin') && !hasRole('superadmin');
  
  if (isAdmin) {
    return <AdminDashboard />;
  }
  
  // Default to superadmin dashboard
  return <Dashboard />;
};

export default DashboardRouter;

